import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { UPLOAD_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const UploadRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={UPLOAD_ROUNDED_GLYPH} />;
